import React, { useEffect, useState } from 'react';
import { Button, InputNumber } from 'antd';
import type { ExploreFilters } from 'services/exploreService';

export const AgeRange: React.FC<{
  filters: ExploreFilters;
  update: (patch: Partial<ExploreFilters>) => void;
}> = ({ filters, update }) => {
  const [min, setMin] = useState<number | null>(filters.age_min ?? null);
  const [max, setMax] = useState<number | null>(filters.age_max ?? null);
  useEffect(() => {
    setMin(filters.age_min ?? null);
    setMax(filters.age_max ?? null);
  }, [filters.age_min, filters.age_max]);
  const invalid = min != null && max != null && min > max;
  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      <InputNumber
        aria-label="Minimum age (years)"
        placeholder="Age min"
        min={0}
        max={150}
        value={min}
        onChange={setMin}
        style={{ width: 110 }}
      />
      <span>–</span>
      <InputNumber
        aria-label="Maximum age (years)"
        placeholder="Age max"
        min={0}
        max={150}
        value={max}
        onChange={setMax}
        style={{ width: 110 }}
      />
      <Button
        disabled={invalid}
        onClick={() => update({ age_min: min ?? undefined, age_max: max ?? undefined })}
      >
        Apply age
      </Button>
      {invalid && <span role="alert">Minimum age must not exceed maximum.</span>}
    </span>
  );
};
